import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15 11l-3 3l-3 -3","key":"svg-0"}],["path",{"d":"M12 3a9 9 0 1 0 0 18a9 9 0 0 0 0 -18","key":"svg-1"}]]

/**
 * IconCircleChevronDown
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY2lyY2xlLWNoZXZyb24tZG93biIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMTUgMTFsLTMgM2wtMyAtMyIgLz4KICA8cGF0aCBkPSJNMTIgM2E5IDkgMCAxIDAgMCAxOGE5IDkgMCAwIDAgMCAtMTgiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/circle-chevron-down
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCircleChevronDown = createReactComponent('outline', 'circle-chevron-down', 'CircleChevronDown', __iconNode);

export default IconCircleChevronDown;